import { FC } from 'react';
import styled from '@emotion/styled';

interface Props {
  image_url: string;
}

export const OverseaDirectBanner: FC<React.PropsWithChildren<Props>> = ({ image_url }) => {
  return (
    <Wrapper>
      <Image src={image_url} alt='Oversea Direct Banner' />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 0 0 24px 0;
`;

const Image = styled.img`
  width: 100%;
  object-fit: fill;
`;
